function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { CssContainer } from "../../components/container";
import { PageHeader, Ribbon, Card, Empty, PlunkDropDown } from "../../components/analytics-kit";
import { Loader, ChartLoader } from "../../components/loaders";
import Error from "../../components/error";
import Chart from "../../components/chart";
import { hasTenantFeature } from "../../functions/tenant-features";
import { trendLabel } from "../sales/territory-common";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { Menu } from "../products/px-common";
import { fetchStore, fetchStoreTrend, isInProgressRange, isAdminUser, stMoney, stDollars, stCount, stPct, stChange, storeName, typeLabel, categoryKey, categoryName, stRangeLabel, goalPhrase, categoryLeaf, periodWord, compareLabel, MiniSpark, GoalBar, Change } from "./common";
import SalesMapCard from "../sales/map-card";

/*
 * Stores overview (Stores redesign 2026-10-09, PlunkDocs mockups/stores-redesign-2026-10-09.html, board "1 · Stores").
 *
 *   GET /v1/store/performance/{range}                   roster + chain totals + goals + pacing (Service.Activity 1.0.174)
 *   GET /v1/store/performance/{range}?$groupBy=trend    sales by store, bucketed day | week | month
 *   GET /v1/store/performance/{range}?$groupBy=category store × category grid (categories merged by name)
 *
 * Changes are like-for-like: an in-progress window (this month) is compared with the same days of the
 * previous period (Oct 1 to 9 vs Sep 1 to 9), computed server-side. "On track for" projects the finish
 * from sales so far. Styles: st-* in sass/v2/_stores.scss.
 */
const SORTS = [["revenue", "Revenue"], ["pace", "Progress to goal"], ["change", "Change"], ["orders", "Orders"], ["aov", "Average order"], ["name", "Name"]];
const SERIES_COLORS = ["#ff6358", "#2d73f5", "#14b8a6", "#f2b134", "#8f6ad8", "#9fb3c8", "#e0679a", "#5a6b7d"];
class StoresView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "open", s => {
      this.props.history.push(`/Stores/${this.range()}/store/${encodeURIComponent(s.storeId)}`);
    });
    _defineProperty(this, "goals", () => {
      this.props.history.push("/Stores/targets");
    });
    this.state = {
      data: null,
      matrix: null,
      trend: undefined,
      error: false,
      sort: "revenue"
    };
    this._alive = true;
  }
  range() {
    return this.props.params && this.props.params.range || getGlobalRange("this_year");
  }
  componentDidMount() {
    this.load();
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!range || !this._alive) return;
      const target = `/Stores/${range}`;
      if (window.location.pathname === target) {
        this.setState({
          data: null,
          matrix: null,
          trend: undefined,
          error: false
        }, () => this.load());
      } else {
        this.props.history.push(target);
      }
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }
  componentDidUpdate(prev) {
    if ((prev.params && prev.params.range) !== (this.props.params && this.props.params.range)) {
      this.setState({
        data: null,
        matrix: null,
        trend: undefined,
        error: false
      });
      this.load();
    }
  }
  load() {
    const range = this.range();
    fetchStore(`/store/performance/${range}`).then(d => this._alive && this.setState({
      data: d || {}
    })).catch(() => this._alive && this.setState({
      error: true
    }));
    fetchStore(`/store/performance/${range}?$groupBy=category`).then(m => this._alive && this.setState({
      matrix: m && m.items || []
    })).catch(() => this._alive && this.setState({
      matrix: []
    }));
    fetchStoreTrend(range).then(t => this._alive && this.setState({
      trend: t && Array.isArray(t.series) ? t : null
    })).catch(() => this._alive && this.setState({
      trend: null
    }));
  }
  downloadList(stores, hasTargets) {
    const esc = v => `"${String(v == null ? "" : v).replace(/"/g, '""')}"`;
    let csv = ["Store", "Type", "Revenue", hasTargets ? "Goal" : null, hasTargets ? "Share of goal %" : null, hasTargets ? "On track for %" : null, "Revenue same days before", "Orders", "Average order", "Share %"].filter(x => x != null).join(",") + "\n";
    stores.forEach(s => {
      csv += [esc(storeName(s)), typeLabel(s.type), Math.round(Number(s.revenue) || 0), hasTargets ? Math.round(Number(s.targetRevenue) || 0) : null, hasTargets ? s.attainmentPct != null ? Math.round(s.attainmentPct) : "" : null, hasTargets ? s.paceAttainmentPct != null ? Math.round(s.paceAttainmentPct) : "" : null, Math.round(Number(s.revenuePrev) || 0), Number(s.orders) || 0, Math.round(Number(s.aov) || 0), Math.round(Number(s.sharePct) || 0)].filter(x => x !== null).join(",") + "\n";
    });
    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `stores-${this.range()}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
  sorted(stores) {
    const {
      sort
    } = this.state;
    const val = s => {
      if (sort === "pace") return s.paceAttainmentPct != null ? Number(s.paceAttainmentPct) : -1;
      if (sort === "change") {
        const c = stChange(s.revenue, s.revenuePrev);
        return c ? (Number(s.revenue) - Number(s.revenuePrev)) / Number(s.revenuePrev) : -1e9;
      }
      if (sort === "orders") return Number(s.orders) || 0;
      if (sort === "aov") return Number(s.aov) || 0;
      return Number(s.revenue) || 0;
    };
    const out = stores.slice();
    if (sort === "name") out.sort((a, b) => storeName(a).localeCompare(storeName(b)));else out.sort((a, b) => val(b) - val(a));
    return out;
  }

  // ---- tiles ----
  tiles(data, stores, range) {
    const inProgress = data.inProgress != null ? !!data.inProgress : isInProgressRange(range);
    const label = compareLabel(data, range);
    const chg = stChange(data.chainRevenue, data.chainRevenuePrev != null ? data.chainRevenuePrev : stores.reduce((a, s) => a + (Number(s.revenuePrev) || 0), 0));
    const units = Number(data.chainUnits) || 0;
    const withGoal = stores.filter(s => Number(s.targetRevenue) > 0);
    const hasTargets = !!data.hasTargets && withGoal.length > 0;
    const tiles = [{
      l: "Revenue",
      v: stMoney(data.chainRevenue),
      s: !label ? "" : chg ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Change, {
        c: chg
      }), " vs ", label) : `nothing sold in ${label} to compare`
    }, {
      l: "Orders",
      v: stCount(data.chainOrders),
      s: `${stCount(units)} units · ${stDollars(data.chainAov)} average`
    }];
    if (hasTargets) {
      const pace = data.chainPaceAttainmentPct;
      const att = Number(data.chainAttainmentPct) || 0;
      tiles.push({
        l: "Against goal",
        v: `${stPct(att)} of ${stMoney(data.chainTarget)}`,
        s: inProgress && pace != null ? `on track to finish at ${stPct(pace)} of the goal` : att >= 100 ? "goal reached" : `finished ${stMoney(Number(data.chainTarget) - Number(data.chainRevenue))} short`
      });
      const key = s => Number(inProgress ? s.paceAttainmentPct : s.attainmentPct) || 0;
      const ahead = withGoal.filter(s => key(s) >= 100).sort((a, b) => key(b) - key(a));
      const behind = withGoal.filter(s => key(s) < 100).sort((a, b) => key(a) - key(b));
      const names = list => list.length <= 2 ? list.map(storeName).join(" and ") : `${storeName(list[0])}, ${storeName(list[1])} and ${list.length - 2} more`;
      const parts = [];
      if (ahead.length) parts.push(`${names(ahead)} ${ahead.length === 1 ? "is" : "are"} ${inProgress ? "on track" : "past the goal"}`);
      if (behind.length) parts.push(`${storeName(behind[0])} ${inProgress ? "needs attention" : "fell furthest short"}`);
      tiles.push({
        l: inProgress ? "Stores ahead of goal" : "Stores that reached the goal",
        v: `${ahead.length} of ${withGoal.length}`,
        s: parts.join("; ")
      });
    } else {
      tiles.push({
        l: "Against goal",
        v: "No goals yet",
        s: isAdminUser() ? /*#__PURE__*/React.createElement("a", {
          className: "st-link",
          href: "#",
          onClick: e => {
            e.preventDefault();
            this.goals();
          }
        }, "Set store goals") : "goals are set by an administrator"
      });
      const outlets = stores.filter(s => s.type === "outlet").length;
      tiles.push({
        l: "Stores",
        v: stCount(stores.length),
        s: outlets ? `${stores.length - outlets} ${stores.length - outlets === 1 ? "store" : "stores"} and ${outlets} ${outlets === 1 ? "outlet" : "outlets"}` : ""
      });
    }
    return tiles;
  }

  // ---- store list ----
  renderList(data, stores, range) {
    const {
      sort
    } = this.state;
    const hasTargets = !!data.hasTargets;
    const inProgress = data.inProgress != null ? !!data.inProgress : isInProgressRange(range);
    const label = compareLabel(data, range);
    const shortLabel = label ? `vs ${label.replace(/^the /, "")}` : "Change";
    const unnamed = stores.filter(s => /^\d+$/.test(String(s.storeId || "").trim()) && /^(Outlet|Store) \d+$/.test(storeName(s)));
    return /*#__PURE__*/React.createElement("section", {
      className: "st-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-card-h"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, "Stores"), /*#__PURE__*/React.createElement("span", {
      className: "st-muted st-small"
    }, "click a store for its page"), /*#__PURE__*/React.createElement("span", {
      className: "st-fill"
    }), /*#__PURE__*/React.createElement("span", {
      className: "st-muted st-small"
    }, "Sort"), /*#__PURE__*/React.createElement("span", {
      className: "st-sort"
    }, /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "170px",
      value: sort,
      onChange: v => this.setState({
        sort: v
      }),
      options: SORTS.filter(([k]) => hasTargets || k !== "pace")
    }))), stores.length ? /*#__PURE__*/React.createElement("div", {
      className: "st-scroll"
    }, /*#__PURE__*/React.createElement("table", {
      className: "st-table st-list"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Store"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Revenue"), /*#__PURE__*/React.createElement("th", null, "Progress to ", goalPhrase(range)), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, shortLabel), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Orders"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Average order"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Share"), /*#__PURE__*/React.createElement("th", null, "Last 30 days"))), /*#__PURE__*/React.createElement("tbody", null, stores.map(s => {
      const c = stChange(s.revenue, s.revenuePrev);
      const goal = Number(s.targetRevenue) || 0;
      return /*#__PURE__*/React.createElement("tr", {
        key: s.storeId,
        className: "st-click",
        tabIndex: 0,
        onClick: () => this.open(s),
        onKeyDown: e => {
          if (e.key === "Enter") this.open(s);
        }
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "st-name-row"
      }, /*#__PURE__*/React.createElement("b", {
        className: "st-name"
      }, storeName(s)), /*#__PURE__*/React.createElement("span", {
        className: "st-type"
      }, typeLabel(s.type)))), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, /*#__PURE__*/React.createElement("b", null, stMoney(s.revenue))), /*#__PURE__*/React.createElement("td", null, goal > 0 ? /*#__PURE__*/React.createElement("span", {
        className: "st-prog"
      }, /*#__PURE__*/React.createElement(GoalBar, {
        pct: s.attainmentPct
      }), /*#__PURE__*/React.createElement("span", {
        className: "st-muted st-small"
      }, stPct(s.attainmentPct), " of ", stMoney(goal), inProgress && s.paceAttainmentPct != null ? ` · on track for ${stPct(s.paceAttainmentPct)}` : "")) : /*#__PURE__*/React.createElement("span", {
        className: "st-muted st-small"
      }, "No goal set")), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, c ? /*#__PURE__*/React.createElement(Change, {
        c: c
      }) : /*#__PURE__*/React.createElement("span", {
        className: "st-muted"
      }, "-")), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, stCount(s.orders)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, stDollars(s.aov)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, stPct(s.sharePct)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(MiniSpark, {
        values: s.spark
      })));
    })))) : /*#__PURE__*/React.createElement("p", {
      className: "st-muted st-pad"
    }, "No store sales in this date range."), /*#__PURE__*/React.createElement("div", {
      className: "st-foot"
    }, hasTargets && inProgress ? `"On track for" projects this ${periodWord(range)}'s finish from sales so far. ` : "", unnamed.length ? `${unnamed.map(storeName).join(", ")} ${unnamed.length === 1 ? "has" : "have"} no name in your store list yet, so ${unnamed.length === 1 ? "it shows its" : "they show their"} store number.` : ""));
  }

  // ---- sales by store chart (shared chart component, one series per store) ----
  renderTrend() {
    const {
      trend
    } = this.state;
    if (trend === undefined) return /*#__PURE__*/React.createElement("section", {
      className: "st-card st-chart"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, "Sales by store"), /*#__PURE__*/React.createElement(ChartLoader, null));
    if (!trend || !trend.series.length || (trend.periods || []).length < 2) {
      return /*#__PURE__*/React.createElement("section", {
        className: "st-card st-chart"
      }, /*#__PURE__*/React.createElement("b", {
        className: "st-h"
      }, "Sales by store"), /*#__PURE__*/React.createElement("p", {
        className: "st-muted st-pad"
      }, trend ? "Not enough days in this range to draw a chart." : "The chart could not be loaded right now."));
    }
    const bucket = trend.bucket || "day";
    const series = trend.series.map(s => ({
      ...s,
      label: storeName(s)
    }));
    const data = [["Period", ...series.map(s => s.label)]];
    trend.periods.forEach((p, i) => data.push([trendLabel(p, bucket === "month" ? "month" : "day"), ...series.map(s => Math.round(Number(s.values[i]) || 0))]));
    const every = data.length > 40 ? Math.ceil((data.length - 1) / 14) : 1;
    return /*#__PURE__*/React.createElement("section", {
      className: "st-card st-chart"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-card-h"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, "Sales by store"), /*#__PURE__*/React.createElement("span", {
      className: "st-muted st-small"
    }, "by ", bucket)), /*#__PURE__*/React.createElement(Chart, {
      width: "100%",
      height: "300px",
      chartType: "LineChart",
      loader: /*#__PURE__*/React.createElement(ChartLoader, null),
      data: data,
      options: {
        colors: series.map((s, i) => SERIES_COLORS[i % SERIES_COLORS.length]),
        vAxis: {
          format: "short",
          minValue: 0,
          viewWindow: {
            min: 0
          }
        },
        hAxis: {
          showTextEvery: every
        },
        tooltip: {
          format: "currency"
        },
        legend: {
          position: "top"
        },
        pointSize: bucket === "day" && data.length > 35 ? 0 : 4
      }
    }));
  }

  // ---- what sells where (category × store) ----
  renderMatrix(stores) {
    const {
      matrix
    } = this.state;
    if (!matrix || !matrix.length || !stores.length) return null;
    // Merge "Sofas" / "SOFA" again here (older backends send them apart), top 12 by chain revenue.
    const merged = new Map();
    matrix.forEach(r => {
      const k = categoryKey(r.category);
      const cur = merged.get(k) || {
        byStore: {},
        names: []
      };
      const tot = Object.values(r.byStore || {}).reduce((a, v) => a + (Number(v) || 0), 0);
      cur.names.push([r.category, tot]);
      Object.entries(r.byStore || {}).forEach(([sid, v]) => {
        cur.byStore[sid] = (cur.byStore[sid] || 0) + (Number(v) || 0);
      });
      merged.set(k, cur);
    });
    const rows = [...merged.entries()].map(([k, r]) => {
      const names = r.names.sort((a, b) => b[1] - a[1]).map(n => n[0]);
      const normal = names.find(n => {
        const leaf = categoryLeaf(n);
        return !(leaf === leaf.toUpperCase() && /[A-Za-z]/.test(leaf));
      });
      return {
        key: k,
        name: categoryName(normal || names[0]),
        byStore: r.byStore,
        total: Object.values(r.byStore).reduce((a, v) => a + v, 0)
      };
    }).sort((a, b) => b.total - a.total).slice(0, 12);
    const cols = stores.slice().sort((a, b) => (Number(b.revenue) || 0) - (Number(a.revenue) || 0));
    return /*#__PURE__*/React.createElement("section", {
      className: "st-card st-matrix"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-card-h"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, "What sells where"), /*#__PURE__*/React.createElement("span", {
      className: "st-muted st-small"
    }, "top categories \xB7 shading compares stores in each row")), /*#__PURE__*/React.createElement("div", {
      className: "st-scroll"
    }, /*#__PURE__*/React.createElement("table", {
      className: "st-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Category"), cols.map(s => /*#__PURE__*/React.createElement("th", {
      key: s.storeId,
      className: "n"
    }, storeName(s))))), /*#__PURE__*/React.createElement("tbody", null, rows.map(r => {
      const max = Math.max(1, ...cols.map(s => Number(r.byStore[s.storeId]) || 0));
      return /*#__PURE__*/React.createElement("tr", {
        key: r.key
      }, /*#__PURE__*/React.createElement("td", null, r.name), cols.map(s => {
        const v = Number(r.byStore[s.storeId]) || 0;
        const heat = v / max;
        return /*#__PURE__*/React.createElement("td", {
          key: s.storeId,
          className: "n",
          style: heat > 0 ? {
            background: `rgba(255,99,88,${(0.05 + 0.18 * heat).toFixed(2)})`
          } : undefined
        }, v > 0 ? stMoney(v) : "-");
      }));
    })))));
  }
  render() {
    if (!hasTenantFeature("storePerformance")) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Store Performance is not configured for this workspace."));
    }
    const {
      data,
      error
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (!data) return /*#__PURE__*/React.createElement(Loader, null);
    const range = this.range();
    const stores = this.sorted((data.stores || []).filter(Boolean));
    const asOfEnd = data.inProgress && data.asOf ? data.asOf : data.end;
    const admin = isAdminUser();
    const menu = [admin ? {
      key: "goals",
      label: "Store goals",
      onClick: this.goals
    } : null, stores.length ? {
      key: "csv",
      label: "Download this list",
      onClick: () => this.downloadList(stores, !!data.hasTargets)
    } : null];
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view stores-view wa-view st-stores"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      title: "Stores",
      subtitle: `How each store is selling against its goal · ${stRangeLabel(range, data.start, asOfEnd)}${compareLabel(data, range) ? ` · changes are against ${compareLabel(data, range)}` : ""}`,
      actions: /*#__PURE__*/React.createElement(React.Fragment, null, admin ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "st-btn",
        onClick: this.goals
      }, "Store goals") : null, /*#__PURE__*/React.createElement(Menu, {
        label: "More",
        items: menu,
        triggerCls: "st-more"
      }))
    }), /*#__PURE__*/React.createElement(Ribbon, {
      comparing: null,
      cols: 4,
      tiles: this.tiles(data, stores, range)
    }), this.renderList(data, stores, range), /*#__PURE__*/React.createElement("div", {
      className: "st-two"
    }, this.renderTrend(), this.renderMatrix(stores)), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(SalesMapCard, {
      range: range,
      want: {
        stores: true
      },
      minStores: 1,
      silentLoading: true,
      title: "Stores on the map",
      hint: "markers coloured by type (store, outlet), sized by revenue",
      onStore: p => this.open({
        storeId: p.id
      })
    })));
  }
}
export default withRouter(StoresView);